<template>
  <div class="divBox">
    <el-card :bordered="false" dis-hover class="ivu-mt">
      <el-form
        ref="thisForm"
        :model="thisForm"
        size="small"
        label-width="80px"
        inline
        label-position="right"
        @submit.native.prevent
      >
        <el-form-item label="关键字：">
          <el-input v-model="thisForm.keyword" placeholder="请输入订单号|用户昵称" />
        </el-form-item>
        <el-form-item label="审核状态：">
          <el-radio-group v-model="thisForm.status" type="button" @change="userSearchs">
            <el-radio-button v-for="item in statusList" :label="item.val">{{ item.label }}</el-radio-button>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" size="small" @click="userSearchs">查询</el-button>
          <el-button size="small" @click="reset">重置</el-button>
        </el-form-item>
      </el-form>
      <el-table :data="lists" ref="table" class="mt25" v-loading="loading">
        <el-table-column prop="id" label="ID" width="50"></el-table-column>
        <el-table-column prop="nickname" label="昵称"></el-table-column>
        <el-table-column prop="ordersn" label="订单号"></el-table-column>
        <el-table-column prop="itemName" label="服务项目"></el-table-column>
        <el-table-column prop="serviceScore" label="订单评分"></el-table-column>
        <el-table-column prop="content" label="评价内容"></el-table-column>
        <el-table-column label="评价图片">
          <template slot-scope="{ row, index }">
            <el-image
              v-if="row.imagesArray"
              style="width: 100px; height: 100px"
              :src="row.imagesArray[0]"
              :preview-src-list="row.imagesArray"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="审核状态">
          <template slot-scope="{ row, index }">
            <el-tag type="info" v-if="row.status == 0">待审核</el-tag>
            <el-tag type="success" v-else-if="row.status == 10">已通过</el-tag>
            <el-tag type="warning" v-else-if="row.status == 20">未通过</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="addTimeDesc" label="评论时间"></el-table-column>
        <el-table-column label="操作" prop="operate" fixed="right">
          <template slot-scope="{ row, index }">
            <span v-if="row.status == 0">
              <el-button @click="verify(row.id)" size="small" type="primary" icon="ios-create">审核</el-button>
              <el-divider direction="vertical"></el-divider>
            </span>
            <a @click="del(row, '删除评价', index)">删除</a>
          </template>
        </el-table-column>
      </el-table>
      <div class="block">
        <el-pagination
          background
          :page-size="thisForm.limit"
          :current-page="thisForm.page"
          :total="total"
          :page-sizes="[20, 40, 60, 80]"
          layout="total, sizes, prev, pager, next, jumper"
          @size-change="handleSizeChange"
          @current-change="pageChange"
        />
      </div>
    </el-card>
    <verify-modal ref="verify" @submitOk="getList"></verify-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getCommentListApi, orderCommentDelApi } from '@/api/order';
import verifyModal from './handle/verifyModal.vue';

export default {
  name: 'order_comment',
  components: { verifyModal },
  data() {
    return {
      grid: {
        xl: 7,
        lg: 7,
        md: 12,
        sm: 24,
        xs: 24,
      },
      loading: false,
      thisForm: {
        page: 1,
        limit: 20,
        keyword: '',
        status: '',
      },
      lists: [],
      timeVal: [],
      options: {
        shortcuts: [
          {
            text: '今天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate()));
              return [start, end];
            },
          },
          {
            text: '昨天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
              );
              end.setTime(
                end.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 1)),
              );
              return [start, end];
            },
          },
          {
            text: '最近7天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 6)),
              );
              return [start, end];
            },
          },
          {
            text: '最近30天',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(
                start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), new Date().getDate() - 29)),
              );
              return [start, end];
            },
          },
          {
            text: '本月',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), new Date().getMonth(), 1)));
              return [start, end];
            },
          },
          {
            text: '本年',
            value() {
              const end = new Date();
              const start = new Date();
              start.setTime(start.setTime(new Date(new Date().getFullYear(), 0, 1)));
              return [start, end];
            },
          },
        ],
      },
      statusList: [
        { label: '全部', val: '' },
        { label: '待审核', val: '0' },
        { label: '已通过', val: '10' },
        { label: '未通过', val: '20' },
      ],
      total: 0,
    };
  },
  computed: {
    ...mapState('media', ['isMobile']),
    labelWidth() {
      return this.isMobile ? undefined : 75;
    },
    labelPosition() {
      return this.isMobile ? 'top' : 'left';
    },
  },
  created() {
    this.getList();
  },
  methods: {
    //订单评价列表
    getList() {
      this.loading = true;
      getCommentListApi(this.thisForm)
        .then(async (data) => {
          this.lists = data.list;
          this.total = data.total;
          this.loading = false;
        })
        .catch((res) => {
          this.loading = false;
          this.$message.error(res.msg);
        });
    },
    pageChange(index) {
      this.thisForm.page = index;
      this.getList();
    },
    // 图片显示
    show(type) {
      let viewer = this.$el.querySelector('.' + type).$viewer;
      viewer.show();
    },
    //状态审核
    verify(id) {
      this.$refs.verify.initData(id);
    },
    // 表格搜索
    userSearchs() {
      this.thisForm.page = 1;
      this.getList();
    },
    reset() {
      this.thisForm = {
        page: 1,
        limit: 20,
        keyword: '',
        status: '',
      };
      this.getList();
    },
    // 删除
    del(row, tit, num) {
      this.loading = true;
      this.$modalSure(tit)
        .then(() => {
          orderCommentDelApi({ id: row.id }).then((res) => {
            this.loading = false;
            this.$message.success('删除成功');
            this.getList();
          });
        })
        .catch((err) => {
          this.loading = false;
        });
    },
    handleSizeChange(val) {
      this.formData.limit = val;
      this.getList();
    },
  },
};
</script>

<style>
.tabBox_img {
  display: flex;
}

.img {
  margin-right: 5px;
}
</style>
